import { combineReducers } from 'redux';
import user from './user';
import social from './social';
import epg from './epg';
import metrics from './metrics';
import notification from './notification';
import modal from './modal';
import player from './player';
import modalInactivity from './modalInactivity';
import playerpip from './playerpip';
import resume from './resume';
import playermusica from './musica/playermusica';
import contextmenu from './musica/contextmenu';
import pinCodes from './pinCodes';
import playlistdetails from './musica/playlistdetails';
import { linealChannels } from './payway';
import playerstates from './playerstates';
import profile from './profile';
import favorites from './musica/favorites';
import navbar from './navbar';
import playerContentData from './playerContentData';
import flagAlertBelt from './musica/alert-header-reducer';
import modalKeepWatching from './modalKeepWatching';
import searcher from "./searcher"
import ads from './ads'
import plans from './plans'
import modalsuccesactive from './modalsuccesactive'

export default combineReducers({
  user,
  epg,
  metrics,
  notification,
  modal,
  linealChannels,
  player,
  resume,
  modalInactivity,
  playerpip,
  playerstates,
  playermusica,
  playlistdetails,
  social,
  contextmenu,
  pinCodes,
  profile,
  favorites,
  navbar,
  playerContentData,
  flagAlertBelt,
  modalKeepWatching,
  searcher,
  ads,
  plans,
  modalsuccesactive
  //test: playerstates /* <--- alternativa para name/prop/attr en state: uso de un 'alias' */
})



// WEBPACK FOOTER //
// ./src/reducers/index.js